import React, {FC, useMemo} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {LinkedConversationActivityRolesEnum} from '../../../../../models/api/activityModel';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {unlinkConversationAsyncAction} from '../../../../../store/data/conversations/linkedConversations/linkedConversationsActions';
import {makeGetLinkedConversationActivitiesByConversationId} from '../../../../../store/data/conversations/linkedConversationsSelectors';

const unlinkText = (
  <Trans id="unlink-conversations-dropdown-more-text">Unlink from original conversation</Trans>
);

interface UnlinkConversationDropdownMoreItemProps {
  onlyConversation: ConversationModel;
}

export const UnlinkConversationDropdownMoreItem: FC<UnlinkConversationDropdownMoreItemProps> = (props) => {
  const dispatch = useAppDispatch();
  const theme = useUserTheme();
  const getLinkedConversationActivities = useMemo(
    () => makeGetLinkedConversationActivitiesByConversationId(props.onlyConversation.id),
    [props.onlyConversation.id],
  );
  const linkedConversationActivities = useAppSelector(getLinkedConversationActivities);
  const isLinkedConversationActivityValid =
    linkedConversationActivities.length === 1 &&
    linkedConversationActivities[0].linkedConversationRole === LinkedConversationActivityRolesEnum.ORIGINAL;

  if (!isLinkedConversationActivityValid) {
    return null;
  }

  const onUnlinkConversationsSelect = () => {
    dispatch(unlinkConversationAsyncAction(linkedConversationActivities[0]));
  };

  return (
    <DropdownItem onSelect={onUnlinkConversationsSelect}>
      <DropdownItemIcon
        label={unlinkText}
        iconSize={16}
        color={theme.greys.shade80}
        iconName="unlinkedConversationsSmall"
      />
      <DropdownItemContent>{unlinkText}</DropdownItemContent>
    </DropdownItem>
  );
};
